var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"trs-dot-wrap",attrs:{"title":_vm.state}},[_c('span',{staticClass:"status-dot",class:_vm.meta.cls}),_c('span',{staticClass:"trs-label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }